'use client';

import { observer } from 'mobx-react-lite';
import useClosedSearchEvent from 'hooks/useClosedSearchEvent';
import { updateUrlQueryParam } from 'utils/misc';
import { ClosedSearchSubHeader } from 'components/new-components/ClosedSearchSubHeader';
import SearchEventList from 'components/SearchEventList/SearchEventList';
import { Container, SearchBodyContainer } from 'components/new-components/Container/Container.css';
import SearchContent from 'components/Shared/SearchContent/SearchContent';
import { ParamsMapSearch, ParamsResult } from 'ParamsResult.d';
import { SearchEventResult } from 'searchEvent';
import { urlParamsSearch } from 'constants/search';

export type ClosedSearchEventTemplateProps = {
  params: ParamsResult;
  searchDataResult: SearchEventResult;
  isMobile: boolean;
  paramsMapSearch?: ParamsMapSearch;
};

function ClosedSearchEventTemplate({
  searchDataResult,
  params,
  isMobile,
  paramsMapSearch,
}: ClosedSearchEventTemplateProps) {
  const closedSearchEventStore = useClosedSearchEvent();
  closedSearchEventStore.hydrate(searchDataResult);
  if (paramsMapSearch) closedSearchEventStore.hydrateParams(paramsMapSearch);

  return (
    <div>
      <ClosedSearchSubHeader params={params} />
      <div className={SearchBodyContainer}>
        <div className={Container}>
          <SearchContent
            pageTypeText="eventos"
            searchResult={closedSearchEventStore?.searchDataResult}
            totalPages={closedSearchEventStore?.totalPages}
            isFetching={closedSearchEventStore?.isFetching}
            isMobile={isMobile}
            onChangePage={(page: string | number) => {
              if (!isMobile) {
                updateUrlQueryParam({ param: urlParamsSearch.page, value: String(page) });
              }

              closedSearchEventStore.fetchPaginationData({
                query: window?.location?.search,
                isMobile,
                page,
                onSuccess: () => window?.scrollTo({ top: 0, left: 0 }),
              });
              return +page;
            }}
          >
            <SearchEventList events={closedSearchEventStore?.searchDataResult?.data} serviceParams={params} isMobile={isMobile} />
          </SearchContent>
        </div>
      </div>
    </div>
  );
}

export default observer(ClosedSearchEventTemplate);
